import { render, staticRenderFns } from "./recordForm.vue?vue&type=template&id=7acbadd4&scoped=true&"
import script from "./recordForm.vue?vue&type=script&lang=js&"
export * from "./recordForm.vue?vue&type=script&lang=js&"
import style0 from "./recordForm.vue?vue&type=style&index=0&id=7acbadd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acbadd4",
  null
  
)

export default component.exports